import { REQUEST_FILTERS, RECEIVE_FILTERS } from "./actionTypes";

import { setInitialQuery } from "../search/actions";
import { requestResults } from "../results/actions";
import { isInitialized } from "./selectors";

export const requestFilters = (back) => (dispatch, getState) => {
  const isCached = isInitialized(getState());

  if (!isCached) {
    dispatch({
      type: REQUEST_FILTERS,
    }).then(response => {
      dispatch(receiveFilters(response.data));
      dispatch(setInitialQuery());
      dispatch(requestResults(back));
    });
  }else{
    dispatch(setInitialQuery());
    dispatch(requestResults(back));
  }
};

export const receiveFilters = filters => ({
  type: RECEIVE_FILTERS,
  payload: filters,
});
